<footer class="app-footer">
  © {{ currentYear }} Adore The Balloon. All rights reserved.
</footer>
